var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'intronav-container': true , 'active': _vm.isActive }},_vm._l((_vm.navItems),function(navItem,index){return _c('div',{key:navItem.title,class:{
      'intronav-item': true,
      'active': navItem.title == _vm.activeItem || (!_vm.isActive && index == 0),
    }},[_c('a',{attrs:{"href":navItem.href}},[_vm._v(_vm._s(navItem.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }